function ScrollToTop() {
  window.scrollTo(0, 0);
  return null;
}

export default ScrollToTop;